module.exports = __webpack_public_path__ + "img/decori_esterni.4350cf6d.jpg";